import { styled, SvgIcon, SvgIconProps } from '@mui/material';
import { OverrideProps } from '@mui/material/OverridableComponent';

export const StyledSvgIcons = styled(SvgIcon)(({ theme }) => ({
  fill: 'none !important',
})) as OverrideProps<SvgIconProps<any, any>, any>;
